module.exports = __webpack_public_path__ + "f9f30038b591ff7c0cb448fd415109e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/13_PROP_08.png
// module id = 113
// module chunks = 0